import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../store/auth-context";
import styles from "../styles/TenantList.module.css";

const TenantsList = () => {
  const authCtx = useContext(AuthContext);

  const list =
    authCtx.tenants &&
    authCtx.tenants.length > 1 &&
    authCtx.tenants.map((tenant) => {
      return (
        <li key={tenant.slug} className={`col-3`}>
          <Link
            to={`/${tenant.slug}`}
            onClick={() => authCtx.setTenant(tenant.slug, tenant.uuid)}
            className={`${styles.tenantDetails} d-block`}
          >
            <p className={styles.thumbnail}>
              <i className="bi bi-globe2"></i>
            </p>
            <h3>{tenant.name}</h3>
            <p className={styles.tenantLink}>{`${
              window.location.href + tenant.slug
            }`}</p>
            <p className={styles.redirectIcon}>
              <i className="bi bi-box-arrow-up-right"></i>
            </p>
          </Link>
        </li>
      );
    });

  return (
    <div className={`${styles.tenantList} container bodyContainer`}>
      <div className={styles.welcomeMessage}>
        <h6>Hi {authCtx.firstName},</h6>
        <p>You are associated with multiple tenants. Choose one to begin.</p>
      </div>
      <ul className={`row list-unstyled`}>{list}</ul>
    </div>
  );
};

export default TenantsList;
